import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_URL,
});

export default apiClient;
